import React, { useState, createContext, useContext } from 'react';
interface Notification {
  id: string;
  title: string;
  message: string;
  type: 'info' | 'success' | 'warning';
  read: boolean;
  timestamp: Date;
}
interface NotificationContextType {
  notifications: Notification[];
  unreadCount: number;
  markAsRead: (id: string) => void;
  addNotification: (notification: Omit<Notification, 'id' | 'read' | 'timestamp'>) => void;
}
const NotificationContext = createContext<NotificationContextType | undefined>(undefined);
export function NotificationProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [notifications, setNotifications] = useState<Notification[]>([{
    id: '1',
    title: 'Streak Saver Used!',
    message: 'You missed yesterday but your streak is safe.',
    type: 'warning',
    read: false,
    timestamp: new Date()
  }, {
    id: '2',
    title: 'Level Up!',
    message: 'Congratulations! You reached Level 5.',
    type: 'success',
    read: true,
    timestamp: new Date(Date.now() - 86400000)
  }]);
  const unreadCount = notifications.filter(n => !n.read).length;
  const markAsRead = (id: string) => {
    setNotifications(prev => prev.map(n => n.id === id ? {
      ...n,
      read: true
    } : n));
  };
  const addNotification = (notification: Omit<Notification, 'id' | 'read' | 'timestamp'>) => {
    const newNotification: Notification = {
      ...notification,
      id: Math.random().toString(36).substr(2, 9),
      read: false,
      timestamp: new Date()
    };
    setNotifications(prev => [newNotification, ...prev]);
  };
  return <NotificationContext.Provider value={{
    notifications,
    unreadCount,
    markAsRead,
    addNotification
  }} data-id="element-602">
      {children}
    </NotificationContext.Provider>;
}
export function useNotifications() {
  const context = useContext(NotificationContext);
  if (context === undefined) {
    throw new Error('useNotifications must be used within a NotificationProvider');
  }
  return context;
}